import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.662992, 166.985096, 12.8],
  [-11.662796, 166.985139, 12.8],
  [-11.662595, 166.985106, 12.8],
  [-11.662406, 166.985031, 12.8],
  [-11.662231, 166.984924, 12.8],
  [-11.662092, 166.984795, 12.8],
  [-11.66199, 166.984613, 12.8],
  [-11.661895, 166.98442, 12.8],
];

export default stream;
